import { useEffect, useState } from 'react';

import { CouponModal } from './CouponModal';
import Button from '../../components/button/Button';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { getCouponsThunk } from '../../redux/reducer/propSlice';

const Coupons: React.FC = () => {
  const dispatch = useAppDispatch();
  const [modalIndex, setModalIndex] = useState<number | undefined>(undefined);
  const { coupons } = useAppSelector(state => state.prop);

  useEffect(() => {
    dispatch(getCouponsThunk());
  }, []);

  return (
    <div className="bg-white pl-4 pt-2 font-medium pb-6 w-10/12">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Coupons</h1>
        <Button
          label="Add Coupon"
          className="bg-[#35E0A1] text-black px-4 py-2 rounded"
          onClick={() => setModalIndex(coupons?.length ?? 0)}
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        {coupons && coupons.length > 0
          ? coupons.map((coupon, index) => (
              <button
                key={index}
                className="bg-[#f6f6f6] p-4 rounded relative"
                tabIndex={0}
                aria-label={`Edit Slot ${coupon.id}`}
                onClick={() => setModalIndex(index)}
              >
                {coupon.code}
              </button>
            ))
          : 'No Coupons Added'}
      </div>
      <CouponModal
        isOpen={modalIndex !== undefined}
        onClose={() => setModalIndex(undefined)}
        coupon={modalIndex !== undefined ? coupons?.at(modalIndex) : undefined}
      />
    </div>
  );
};

export default Coupons;
